export default __webpack_public_path__ + "static/media/user.f0df283d.svg";